module.exports = __webpack_public_path__ + "static/media/DistractionTechniques.fb2ada51.jpg";